/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { real, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const invoices = sqliteTable('invoices', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  clinic_id: text('clinic_id'),
  patient_id: text('patient_id'),
  appointment_id: text('appointment_id'),
  consultation_id: text('consultation_id'),
  queue_id: text('queue_id'),
  encounter_id: text('encounter_id'),
  visit_id: text('visit_id'),
  invoice_no: text('invoice_no'),
  patient_name: text('patient_name'),
  date_iso: text('date_iso'),
  status: text('status'),
  reference_no: text('reference_no'),
  reference_type: text('reference_type'),
  notes: text('notes'),
  subtotal: real('subtotal'),
  discount_total: real('discount_total'),
  tax_total: real('tax_total'),
  grand_total: real('grand_total'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
